/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { handleToggleEngine } from "../../handlers/HomeRoomHandlers";
import { handleSetKeyboard } from "../../handlers/PrivateHandlers";
import { Button, Panel, TableAdvanced, Text } from "vr-react-components";
import { useSelector } from "react-redux";
import React from "react";

const EngineSelectionModal = ({ openedPanelDimension, onClose }) => {
    const engines = useSelector((state) => state.user.engines);
    const canModify = useSelector((state) => state.private.device.canModify);

    const engineData = [
        ["Name", "Owner", "Type", "Status"],
        ...engines.list.map((x) => { return [x.name, x.owner, x.type, x.available] }),
    ]

    const disabledList = [false].concat(engines.list.map((engine) => engine.available))

    const middlewareForHandleToggleEngine = (i) => {
       const label = engines.list[i].name
       handleToggleEngine(label, engines)
    }

    return (
        <a-entity>
            <Text
                text="Engine Selection"
                width={openedPanelDimension}
                sizeDecimal={30 / openedPanelDimension}
                baseline="top"
                position={`${-openedPanelDimension / 2 + openedPanelDimension * 0.05}
                    ${openedPanelDimension / 2 - openedPanelDimension * 0.05} 0`}
            />
            <Button
                text="Close"
                width={openedPanelDimension * 0.4}
                aframeClasses={canModify ? "collidable" : ""}
                height={openedPanelDimension * 0.1}
                onClickHandler={onClose}
                position={`${openedPanelDimension / 2 -
                    openedPanelDimension * 0.05 -
                    openedPanelDimension * 0.2
                    } ${-openedPanelDimension / 2 +
                    openedPanelDimension * 0.05 +
                    openedPanelDimension * 0.05
                    } 0.001`}
                type={Button.constants.primary}
                textSizeDecimal={40 / openedPanelDimension}
            />
            <Panel
                width={openedPanelDimension}
                height={openedPanelDimension * 0.7}
                aframeClasses={canModify ? "collidable" : ""}
                resize
            >
                <TableAdvanced
                    keyboardHandler={handleSetKeyboard}
                    search
                    checkbox
                    setChecked={(label) => handleToggleEngine(label, engines)}
                    onRowClick={(_, i) => middlewareForHandleToggleEngine(i)}
                    aframeClasses={canModify ? "collidable" : ""}
                    checkboxesState={engines.selected}
                    data={engineData}
                    disabledList={disabledList}
                    disabled={false}
                />
            </Panel>
        </a-entity>
    );
}

export default EngineSelectionModal;
